// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.radio-group-city[data-v-0b47a352] .el-radio{\n  display: block;\n  line-height: 28px;\n}\n", ""]);
// Exports
module.exports = exports;
